var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "project-calendar" }, [
    _c("header", { staticClass: "calendar-toolbar" }, [
      _c("div", [
        _c("span", { staticClass: "calendar-kicker" }, [
          _vm._v(_vm._s(_vm.$t("projects.calendar")))
        ]),
        _c("h2", { staticClass: "month-name" }, [_vm._v(_vm._s(_vm.monthName))])
      ]),
      _c("div", { staticClass: "calendar-navigation" }, [
        _c(
          "button",
          {
            staticClass: "calendar-nav-button icon-only",
            attrs: { type: "button" },
            on: {
              click: function($event) {
                return _vm.$refs.calendar.prev()
              }
            }
          },
          [_c("portal-icon", { attrs: { name: "chevron-left", size: 18 } })],
          1
        ),
        _c(
          "button",
          {
            staticClass: "calendar-nav-button today-button",
            attrs: { type: "button" },
            on: {
              click: function($event) {
                return _vm.today()
              }
            }
          },
          [_vm._v(" " + _vm._s(_vm.$t("meetings.filter.today")) + " ")]
        ),
        _c(
          "button",
          {
            staticClass: "calendar-nav-button icon-only",
            attrs: { type: "button" },
            on: {
              click: function($event) {
                return _vm.$refs.calendar.next()
              }
            }
          },
          [_c("portal-icon", { attrs: { name: "chevron-right", size: 18 } })],
          1
        )
      ])
    ]),
    _c(
      "div",
      { staticClass: "calendar-surface" },
      [
        _c("v-calendar", {
          ref: "calendar",
          staticClass: "calendar-grid",
          attrs: { id: "calendar", weekdays: _vm.weekdays, type: "month" },
          on: { "mouseenter:day": _vm.mouseMove, "mouseup:day": _vm.mouseUp },
          nativeOn: {
            mouseleave: function($event) {
              return _vm.mouseUp.apply(null, arguments)
            }
          },
          scopedSlots: _vm._u([
            {
              key: "day-label",
              fn: function(ref) {
                var day = ref.day
                return [
                  day !== _vm.todayNumber
                    ? _c("div", { staticClass: "dayLabel" }, [
                        _vm._v(" " + _vm._s(day) + " ")
                      ])
                    : _c("div", { staticClass: "dayLabel" }, [
                        _c("div", { staticClass: "todayLabel" }, [
                          _vm._v(_vm._s(day))
                        ])
                      ])
                ]
              }
            },
            {
              key: "day",
              fn: function(ref) {
                var date = ref.date
                return [
                  _c(
                    "div",
                    {
                      staticClass: "day",
                      style: "--day-height: " + _vm.dayHeight + "px;",
                      on: {
                        click: function($event) {
                          return _vm.addDeliverable(date)
                        }
                      }
                    },
                    [
                      _vm._l(_vm.events.get(date), function(event, index) {
                        return _c(
                          "div",
                          { key: event.id },
                          [
                            index < _vm.maxItems ||
                            (index === _vm.maxItems &&
                              index === _vm.events.get(date).length - 1)
                              ? _c("calendar-item", {
                                  attrs: {
                                    event: event,
                                    status: _vm.getStatus(event)
                                  },
                                  on: {
                                    "start-drag": function($event) {
                                      return _vm.startDrag($event)
                                    },
                                    "edit-deliverable": function($event) {
                                      return _vm.editDeliverable($event)
                                    }
                                  }
                                })
                              : _vm._e()
                          ],
                          1
                        )
                      }),
                      _vm.events.get(date) &&
                      _vm.events.get(date).length > _vm.maxItems + 1
                        ? _c(
                            "v-menu",
                            {
                              attrs: {
                                "close-on-content-click": true,
                                "nudge-top": _vm.dayHeight,
                                "content-class": "calendar-overflow-menu"
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "activator",
                                    fn: function(ref) {
                                      var on = ref.on
                                      return [
                                        _c(
                                          "button",
                                          _vm._g(
                                            {
                                              staticClass: "has-more",
                                              attrs: { type: "button" }
                                            },
                                            on
                                          ),
                                          [
                                            _vm._v(
                                              " + " +
                                                _vm._s(
                                                  _vm.events.get(date).length -
                                                    _vm.maxItems
                                                ) +
                                                " " +
                                                _vm._s(_vm.$t("global.more")) +
                                                " "
                                            )
                                          ]
                                        )
                                      ]
                                    }
                                  }
                                ],
                                null,
                                true
                              )
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "calendar-overflow-content" },
                                [
                                  _c("header", [
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(_vm.moment(date).format("ddd"))
                                      )
                                    ]),
                                    _c("strong", [
                                      _vm._v(
                                        _vm._s(_vm.moment(date).format("D"))
                                      )
                                    ])
                                  ]),
                                  _c(
                                    "div",
                                    { staticClass: "calendar-overflow-list" },
                                    _vm._l(_vm.events.get(date), function(
                                      event
                                    ) {
                                      return _c("calendar-item", {
                                        key: event.id,
                                        attrs: {
                                          event: event,
                                          status: _vm.getStatus(event)
                                        },
                                        on: {
                                          "start-drag": function($event) {
                                            return _vm.startDrag($event)
                                          },
                                          "edit-deliverable": function($event) {
                                            return _vm.editDeliverable($event)
                                          }
                                        }
                                      })
                                    }),
                                    1
                                  )
                                ]
                              )
                            ]
                          )
                        : _vm._e()
                    ],
                    2
                  )
                ]
              }
            }
          ]),
          model: {
            value: _vm.value,
            callback: function($$v) {
              _vm.value = $$v
            },
            expression: "value"
          }
        })
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }